import { IApiAdTargeting } from 'redux-state/advertisement/types.js';
import { TargetingOverride } from 'typings/window.js';
import { getWindow } from 'utilities/window.js';

/**
 * Get override vars.
 * If is playwright merges playwright ones,
 * otherwise uses ones that are on the window object
 */
const getTargetingOverride = (): TargetingOverride | undefined => {
  const lclWindow = getWindow();
  if (lclWindow?.playwright?.isPlaywright) {
    return { ...lclWindow?.targetingOverride, ...lclWindow.playwright.targeting };
  }

  /**
   * Check if we have any env vars set for site / type
   * Only ad it site is set as type without site is not valid
   */
  const lclEnvAdSite = __AD_TARGET_SITE__;
  const lclEnvAdType = __AD_TARGET_TYPE__;
  const lclEnvAdOverride = lclEnvAdSite ? { site: lclEnvAdSite, type: lclEnvAdType } : undefined;

  return { ...lclWindow?.targetingOverride, ...lclEnvAdOverride };
};

/**
 * Mutates targetingData to override with server side include site overide if present
 * Mutating here as it is easier to manage, but be careful
 * */
export const applySiteOverideTargetting = (coreTargeting: IApiAdTargeting[]): IApiAdTargeting[] => {
  const overrideObject = getTargetingOverride() ?? {};
  for (const overrideObjectKey in overrideObject) {
    const newOverrideObject = { key: overrideObjectKey, value: overrideObject[overrideObjectKey] };
    const needle = coreTargeting.findIndex((coreTargetingProp) => {
      const isPropSameAsKey = coreTargetingProp.key === overrideObjectKey;
      return isPropSameAsKey;
    });

    if (needle >= 0) {
      // prop exists so update
      coreTargeting.splice(needle, 1, newOverrideObject);
    } else {
      // prop doesnt exist so add
      coreTargeting.push(newOverrideObject);
    }
  }

  return coreTargeting;
};
